<template>
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.00464 3.66667C3.00464 3.29848 3.30312 3 3.67131 3H9.00464C9.37283 3 9.67131 3.29848 9.67131 3.66667C9.67131 4.03486 9.37283 4.33333 9.00464 4.33333H3.67131C3.30312 4.33333 3.00464 4.03486 3.00464 3.66667Z"
      fill="#A5ADB7"
    />
    <path
      d="M3.00464 9C3.00464 8.63181 3.30312 8.33333 3.67131 8.33333H9.00464C9.37283 8.33333 9.67131 8.63181 9.67131 9C9.67131 9.36819 9.37283 9.66667 9.00464 9.66667H3.67131C3.30312 9.66667 3.00464 9.36819 3.00464 9Z"
      fill="#A5ADB7"
    />
    <path
      d="M3.00464 11.6667C3.00464 11.2985 3.30312 11 3.67131 11H9.00464C9.37283 11 9.67131 11.2985 9.67131 11.6667C9.67131 12.0349 9.37283 12.3333 9.00464 12.3333H3.67131C3.30312 12.3333 3.00464 12.0349 3.00464 11.6667Z"
      fill="#A5ADB7"
    />
    <path
      d="M3.00464 14.3333C3.00464 13.9651 3.30312 13.6667 3.67131 13.6667H9.00464C9.37283 13.6667 9.67131 13.9651 9.67131 14.3333C9.67131 14.7015 9.37283 15 9.00464 15H3.67131C3.30312 15 3.00464 14.7015 3.00464 14.3333Z"
      fill="#A5ADB7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1184 7.00004C11.393 7.77684 12.1338 8.33337 13.0046 8.33337C14.1092 8.33337 15.0046 7.43794 15.0046 6.33337C15.0046 5.2288 14.1092 4.33337 13.0046 4.33337C12.1338 4.33337 11.393 4.88991 11.1184 5.66671H3.67131C3.30312 5.66671 3.00464 5.96518 3.00464 6.33337C3.00464 6.70156 3.30312 7.00004 3.67131 7.00004H11.1184ZM13.6713 6.33337C13.6713 6.70156 13.3728 7.00004 13.0046 7.00004C12.6364 7.00004 12.338 6.70156 12.338 6.33337C12.338 5.96518 12.6364 5.66671 13.0046 5.66671C13.3728 5.66671 13.6713 5.96518 13.6713 6.33337Z"
      fill="#10233E"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
